export default {"src":"/_next/static/media/bankIcon (1).4d2f3781.svg","height":72,"width":72};